import PropTypes from 'prop-types';
import React from 'react';
import FluidImage from '@utility/FluidImage/index';
import FigCaption from '@utility/FigCaption';
import PortableText from '@utility/PortableText';
import Parallax from '@utility/Parallax';
import ScrollInView from '@utility/ScrollInView/index';

const ImageTextTrio = ({
  data: { images, heading, paragraph, orientation },
}) => {
  const renderFigure = (i, imageWidth, imageHeight) =>
    images[i] && (
      <ScrollInView>
        <figure>
          <Parallax y={[-15, 15]}>
            <FluidImage
              src={images[i].image}
              maxWidth={imageWidth}
              maxHeight={imageHeight}
            />
          </Parallax>
          {images[i].richText && (
            <FigCaption>
              <PortableText blocks={images[i].richText.richText} />
            </FigCaption>
          )}
        </figure>
      </ScrollInView>
    );

  const renderHeadingBlock = () =>
    heading && (
      <ScrollInView className="pb-12 md:pb-32">
        <div className="has-delay">
          <h2 className="type-sans-730 md:type-sans-930 mb-4 md:mb-8">
            {heading}
          </h2>
          {paragraph && <p className="type-sans-230">{paragraph}</p>}
        </div>
      </ScrollInView>
    );

  const renderNormalOrientation = () => (
    <div className="row">
      <div className="col-12 md:col-6">
        <div className="pb-12 md:pb-32">{renderFigure(0, 1200, 724)}</div>
        <div className="col-10 offset-1 pb-16 md:pb-0">
          <div className="md:min-h-48">{renderHeadingBlock()}</div>
          {renderFigure(2, 990, 1240)}
        </div>
      </div>
      <div className="col-12 md:col-5 md:offset-1">
        <div className="flex flex-col justify-center h-full">
          {renderFigure(1, 990, 1240)}
        </div>
      </div>
    </div>
  );

  const renderReverseOrientation = () => (
    <div className="row">
      <div className="col-12 md:col-5">
        <div className="flex flex-col justify-center h-full pb-16 md:pb-0">
          {renderFigure(1, 990, 1240)}
        </div>
      </div>
      <div className="col-12 md:col-6 md:offset-1">
        <div className="col-10">
          <div className="pb-12 md:pb-32">{renderFigure(0, 780, 976)}</div>
          {renderHeadingBlock()}
        </div>
        {renderFigure(2, 1200, 724)}
      </div>
    </div>
  );

  return (
    <div className="wrapper">
      {orientation === 'normal'
        ? renderNormalOrientation()
        : renderReverseOrientation()}
    </div>
  );
};

ImageTextTrio.propTypes = {
  data: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.object).isRequired,
    heading: PropTypes.string,
    paragraph: PropTypes.string,
    orientation: PropTypes.oneOf(['normal', 'reverse']),
  }),
};

ImageTextTrio.defaultProps = {
  data: {
    heading: '',
    paragraph: '',
    orientation: 'normal',
  },
};

export default ImageTextTrio;
